import { Manager } from 'socket.io-client';
import config from '@platform/shared/config';
import { type SocketNamespace, SocketSession, type SocketSessionAuthPayload } from './socket-session';

const useLocalhost = false;
const sockUrl = useLocalhost ? 'http://localhost:3000' : config.base_api_url;

const namespaces = ['default', 'chats'] as const satisfies readonly SocketNamespace[];

export const manager = new Manager(sockUrl, {
    path: '/api/node-platform/wss',
    autoConnect: false,
    reconnection: true,
    extraHeaders: {
        'Service-ID': config.serviceId,
        'X-Version-Tag': 'v' + config.currentVersion,
        'X-Version-Hash': config.gitLatestCommitSha,
    },
    closeOnBeforeunload: true,
    multiplex: true,
    transports: window.location.pathname.startsWith('/_mobile') ? ['websocket'] : ['polling', 'websocket'],
});

export const socketSessions = namespaces.reduce(
    (acc, namespace) => {
        const nsp = `/${namespace}`;
        const rawSocket = manager.socket(nsp);
        acc[namespace] = new SocketSession(rawSocket, namespace);
        return acc;
    },
    {} as Record<(typeof namespaces)[number], SocketSession>
);

export function forgetSockets(close: boolean = true) {
    for (const namespace of namespaces) {
        socketSessions[namespace].setAuthPayload(null);
        socketSessions[namespace].disconnect();
    }
    if (close) {
        manager._close();
    }
}

export function initializeSockets(options: { auth: SocketSessionAuthPayload }) {
    for (const namespace of namespaces) {
        socketSessions[namespace].setAuthPayload(options.auth);
        socketSessions[namespace].connect();
    }
}
